import React from "react";
import "./style.css";

export const CourseLandingLoop = ({loop, loop_image, text}) => {
  return (
    <div key={loop} className="course_landing_loop_div image_center_scale_wrapper position-relative">
      <video className="d-block w-100" crossOrigin="anonymous" style={{height: '100%', objectFit: 'cover'}} autoPlay muted loop playsInline>
        <source type="video/mp4" src={loop} />
      </video>*
      {/*<img className="d-block w-100" style={{height: '100%', objectFit: 'cover'}} src={loop_image} />*/}
      <div className="course_landing_loop_div_gradient"></div>
      <p style={{"bottom": "0px", "fontSize": "14px"}} className="sweet_sans_bold text-white w-100 pl-1 pr-1 px-1 text-center position-absolute">{text}</p>
    </div>
  );
};
